// extracted by mini-css-extract-plugin
module.exports = {"search":"screenshot_search_2x_u0","tableImg":"screenshot_tableImg_3KmRU"};